<p-card [style]="{ width: '75vw' }">
  <p-table [value]="catalogSubstrates" dataKey="id" editMode="row" class="table-sm">
    <ng-template #header>
      <tr>
        <th>Substrate</th>
        <th>MODS Recipe</th>
        <th style="width: 5rem; text-align: center">Available</th>
        <th style="width: 5rem">Lead Time</th>
        <th style="width: 5rem; text-align: center">Vendor</th>
        <th style="text-align: end; vertical-align: middle"></th>
      </tr>
    </ng-template>
    <ng-template #body let-substrate let-editing="editing" let-rowIndex="rowIndex">
      <tr>
        <td>
          <div class="flex w-full">{{ substrate.substrate.name }}</div>
          <div *ngIf="substrate.isActive == false" class="flex w-full text-red-500 text-xs">Inactive</div>
        </td>
        <td>
          <p-floatlabel variant="on"
            [pTooltip]="isRecipesLookupForbidden ? 'User do not have permission to view recipes' : undefined">
            <p-select inputId="substrateRecipeLookupList" [options]="recipesLookup" data-testid="substrateRecipteId"
              optionLabel="recipeName" optionValue="recipeId" [style]="{ width: '100%' }" class="w-full" appendTo="body"
              (onChange)="onSelectRecipe($event.value, substrate)"
              [disabled]="substrate.isActive == false || substrate.isAvailable === false || recipesLookup.length === 0"
              [(ngModel)]="substrate.recipeId">
              <label for="growthStage">Recipe</label>
            </p-select>
          </p-floatlabel>
        </td>
        <td style="text-align: center">
          <p-toggleswitch [(ngModel)]="substrate.isAvailable" (change)="updateCatalogSubstrate(substrate)"
            [disabled]="substrate.isActive == false" attr.data-testid="isAvailable{{ substrate.id }}" />
        </td>
        <td>
          <p-inputnumber id="leadTime" name="leadTime" [(ngModel)]="substrate.leadTime" inputId="leadTime"
            mode="decimal" [min]="0" [max]="365" [minFractionDigits]="0" [maxFractionDigits]="0" [useGrouping]="false"
            (onInput)="updateCatalogSubstrate(substrate)" attr.data-testid="leadTime{{ substrate.id }}"
            [disabled]="substrate.isActive == false || substrate.isAvailable === false" />
        </td>
        <td style="text-align: center">
          <p-toggleswitch [(ngModel)]="substrate.isExternal" (change)="updateCatalogSubstrate(substrate)"
            [disabled]="substrate.isActive == false || substrate.isAvailable === false"
            attr.data-testid="isExternal{{ substrate.id }}" />
        </td>
        <td style="width: 15rem">
          <app-audit-info [value]="substrate" [direction]="'vertical'"></app-audit-info>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>